<template>
    <div class="list">
        <div class="tit font-size16 jf">
            <div class="btns yx-between">
                <div>用户组</div>
                <div class="tab"></div>
            </div>
        </div>
        <div class="content">
            <div class="top">
                <el-page-header @back="GotoGroup" content=""> </el-page-header>
                <!-- <el-button
                    icon="el-icon-circle-plus"
                    type="primary"
                    plain
                    size="small"
                    @click="Add"
                >
                    批量导入222
                </el-button> -->
            </div>

            <div class="table">
                <el-descriptions title="用户信息">
                    <el-descriptions-item label="用户名"
                        >kooriookami</el-descriptions-item
                    >
                    <el-descriptions-item label="手机号"
                        >18100000000</el-descriptions-item
                    >
                    <el-descriptions-item label="居住地"
                        >苏州市</el-descriptions-item
                    >
                    <el-descriptions-item label="备注">
                        <el-tag size="small">学校</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="联系地址"
                        >江苏省苏州市吴中区吴中大道 1188
                        号</el-descriptions-item
                    >
                </el-descriptions>
            </div>
        </div>
    </div>
</template>

<script>
import {
    GetOrganGroupInfo,
    SaveOrganGroup,
    DeleteOrganGroup
} from "@/api/category";

export default {
    components: {},
    data() {
        return {
            background: true,
            loadingText: "正在加载...",
            listLoading: false,
            data: [],
            // 弹框标题
            dialogTitle: "",
            dialogVisible: false,
            // 用户组表单
            groupForm: {
                ID: 0,
                ParentId: null,
                Name: "",
                RankNum: null,
                DescInfo: ""
            }
        };
    },
    created() {},
    methods: {
        GotoGroup() {
            this.$router.push("/manage/user/group");
        }
    }
};
</script>

<style lang="less" scoped>
.list {
    min-height: 700px;
    width: 100%;
    background: white;
    border-radius: 16px;
    margin: 0 auto;
    margin-bottom: 30px;
}

.tit {
    padding: 20px 20px 0px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e8ec;

    .btns {
        width: 80px;
        height: 35px;
        box-sizing: border-box;
        margin: 0 25px 0 10px;
        cursor: pointer;

        .tab {
            width: 50px;
            height: 4px;
            background: #256cf4;
            border-radius: 2px;
        }
    }
}

.content {
    .top {
        height: 50px;
        line-height: 50px;
        padding-left: 40px;

        .el-page-header {
            height: 50px;
            line-height: 50px;
        }
    }

    .table {
        border-top: 1px solid #e8f1ff;

        padding: 30px 40px;

        .table-btn {
            cursor: pointer;
            margin-left: 5px;
        }
    }

    .dialog-text {
        width: 300px;
    }
}
</style>
